function animate(startValue, endValue, modifier) {
  let time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  let callback = arguments.length > 4 ? arguments[4] : undefined;
  let start = null;
  let timeDelta;
  let value;
  const unitValueDelta = (endValue - startValue) / time;
  function handle(timestamp) {
    if (!start) {
      start = timestamp;
    }
    timeDelta = timestamp - start;
    value = startValue + timeDelta * unitValueDelta;
    if (unitValueDelta > 0 && value >= endValue || unitValueDelta < 0 && value <= endValue) {
      value = endValue;
    }
    modifier(value);
    if (value === endValue) {
      if (callback) {
        callback();
      }
    } else {
      window.requestAnimationFrame(handle);
    }
  }
  window.requestAnimationFrame(handle);
}
export default animate;